import { useEffect, useState } from "react";
import { Rule, RuleGroup } from "../../types/Campaigns";
import useCampaignsService from "../../services/CampaignsService";
import NeutralButton from "../NeutralButton";
import PositiveButton from "../PositiveButton";
import { describeCampaignRule } from "../../utilities/CampaignRuleUtilities";

interface RuleGroupProps {
  campaignId: string;
  rewardId: string;
  ruleGroup: RuleGroup;
  onClick?: (ruleGroup: RuleGroup) => void;
}

export default function RuleGroupListItem({
  campaignId,
  rewardId,
  ruleGroup,
  onClick,
}: RuleGroupProps) {
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState<string>("");

  const { getRulesForRuleGroup } = useCampaignsService();

  const fetchRules = async () => {
    setLoading(true);
    try {
      const rules = await getRulesForRuleGroup(
        campaignId,
        rewardId,
        ruleGroup.id
      );

      setDescription((rules as Rule[]).map((rule) => describeCampaignRule(rule)).join(` ${ruleGroup.logic} `));
    } catch (error) {
      console.error("Error fetching rules:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRules();
  }, [campaignId, rewardId, ruleGroup.id]);

  return (
    <tr key={ruleGroup.id}>
      <td className="p-4">{description}</td>
      <td className="p-4">
        <PositiveButton className="w-full" onClick={() => onClick && onClick(ruleGroup)} disabled={loading}>
          {loading ? "Loading..." : "View / Edit Rules"}
        </PositiveButton>
      </td>
    </tr>
  );
}
